import { legacyApiFilterBuilder } from '../../../filters/legacy-api-filter-builder';
import { getAdvancedSearchReturns } from '../api';
import { getReturnsSuccess, getReturnsFailure, bulkloadAdvancedSearchEntities } from '../../../store/returns/returns.actions';
import { id as fulfillmentTypeId } from '../../../filters/options/fulfillment-type';
import { returns } from '../../../filters/options/fulfillment-type/options';
import Global from '../../../store/global-selectors';
import { ColumnOrderByParamService } from '../../../services/column-orderby-param-service';
import { ReturnsAdvancedSearch } from '../../../components/shipping-grid/views/returns-advanced-search';
import { ADVANCED_SEARCH_ID } from '../../../pages/orders-page/orders-page-view-constants';

export default {
  filterBuilder: legacyApiFilterBuilder,
  apiCall: getAdvancedSearchReturns,
  baseUrl: 'returns',
  successActions: [bulkloadAdvancedSearchEntities, getReturnsSuccess],
  failureAction: getReturnsFailure,
  convertResponse: (response) => response.pageData,
  view: ReturnsAdvancedSearch,
  getOrderBy: (reduxState) => {
    const { filterViewId } = Global.selectShipmentsFilteringActiveFilterView(reduxState);
    const orderBy = Global.selectReturnsGridCurrentOrderByColumn(reduxState, {
      statusViewId: ADVANCED_SEARCH_ID,
      activeFilterViewId: filterViewId,
    });
    const orderByParam = ColumnOrderByParamService.getReturnsGridOrderByApiParamOrDefault(orderBy, true);

    return {
      orderBy: orderByParam,
    };
  },
  initialFilters: [
    {
      id: fulfillmentTypeId,
      value: returns.apiKey,
    },
  ],
};
